enum AlertStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive'
}

export default AlertStatusEnum
